<template>
    <!-- <v-progress-circular class="grow text-center ma-6" v-if="loadingFormulas" indeterminate></v-progress-circular> -->
    <div>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="d-flex flex-grow-1 flex-shrink-0 py-4 align-center">
                    <v-autocomplete
                        dense outlined
                        label="Scegli una formula"
                        :items="formulas"
                        v-model="value"
                        item-text="_id"
                        item-value="_id"
                        return-object
                        hide-details
                        @change="loadFormula"
                        ></v-autocomplete>
                    <v-spacer></v-spacer>
                    <div v-katex:display="equation"></div>
                </div>
            </v-col>
        </v-row>
        <v-row v-if="value" no-gutters>
            <v-col cols="12">
                <div class="">Descrizione</div>
                <v-textarea dense outlined
                    v-model="value.desc"
                    rows="4"
                    hide-details
                />
                <div class="d-flex flex-grow-1 justify-end py-2">
                    <v-btn  color="primary" v-can="{obj_type:'formulas', action: 'edit'}" @click="saveFormulaDesc">salva descrizione</v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="items && blocks.length>0">
            <span >La formula è usata nei seguenti blocchi: </span>
            <span class="ml-2 mb-2">
                <span v-for="item in blocks" :key="item._id">
                    <span class="font-italic">{{item.label}}</span> per <span class="font-weight-bold">{{item.family}}</span><br/></span>
            </span> 
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters v-if="items">
            <v-col cols=12>
            <v-simple-table class="measure_table">
                <template v-slot:default>
                <thead class="expansion">
                    <tr>
                        <th v-for="h of headers" :key="h.value" class="table-text-blocks text-right pt-4">{{ h.text }}</th>
                    </tr>
                </thead>
                    <tr v-for="(item,idx) of items" :key="idx">
                        <td class="table-blocks text-right" v-for="(par, index) in item" :key="index">
                            <NumericField 
                                dense outlined
                                hide-details 
                                clearable
                                v-model="item[index]"
                            ></NumericField>
                        </td>
                        <td v-if="value.fixed_params" class="table-blocks text-right">
                            <b class="pl-2">
                            {{doMagic(item)}}
                            </b>
                        </td>
                    </tr>
                </template>
            </v-simple-table>
                
            </v-col>
            <div v-if="!value.fixed_params">
                <v-col cols="12" v-for="(item, index) in items[0]" :key="index" class="ma-2 ">
                    <b class="title">
                        {{calculateFunction(index)}}
                    </b>
                </v-col>
            </div>
        <!-- <span v-if="!value.fixed_params">
            <b v-for="(par, index) in items[0]" :key="index">
                {{calculateFunction(index)}} --
            </b>
        </span> -->
            <v-col cols="12" class="pt-4">
                <div class="d-flex justify-space-between">
                <VueUploadComponent
                    class="btn d-flex flex-grow-0 flex-shrink-1"
                    ref="upload"
                    v-model="files"
                    @input-file="processFile"
                    @input-filter="inputFilter"
                    v-if="!value.fixed_params"
                    >
                        <v-btn elevation-2 color="primary">Seleziona file </v-btn>
                    </VueUploadComponent>
                <span class="d-flex justify-end flex-grow-1 flex-shrink-0">
                    <v-btn @click="addRow">Aggiungi riga</v-btn>
                    <v-btn class="ml-4" @click="exportData">Esporta risultati</v-btn>
                </span>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import VueUploadComponent from "vue-upload-component";
const nerdamer = require('nerdamer/all');

export default {
    components: {
        VueUploadComponent
    },
    data() {
        return {
            value: "",
            equation: "",
            formulas : [],
            blocks: [],
            items: null,
            headers: [
                {text:"a", value:"a", align:"center", sortable:false},
                {text:"b", value:"b", align:"center", sortable:false},
                {text:"c", value:"c", align:"center", sortable:false},
                {text:"Risultato", value:"result", align:"center", sortable:false}
            ],
            files: [],
            loadingFormulas: true
        }
    },
    methods: {
        doMagic(item){
            let b = JSON.parse(JSON.stringify(item))
            let k = nerdamer(this.value.equation).evaluate(b)
            return k.text()
        },
        async loadFormula(){
            console.log("this.value",this.value)
            this.items = [];
            this.headers = [];
            this.equation = nerdamer.convertToLaTeX(this.value.equation);
            if(this.value.fixed_params){
                for (let elm in this.value.data){
                    this.headers.push(
                        {text: elm, align: "left", sortable: false}
                    )
                }
                this.headers.push( {text: "Risultato", align: "left", sortable: false})
                for(let i=0; i<3; i++){
                    let clone = JSON.parse(JSON.stringify(this.value.data));
                    this.items.push(clone);
                }
            }
            else {
                this.headers.push(
                    {text: 'Values', align: "center", sortable: false}
                )
            }
            await this.getBlocks()
        },
        async saveFormulaDesc() {
            try {
                let formula = await this.$store.state.$pouch.get('masters', this.value._id)
                formula.desc = this.value.desc
                console.log("formula", formula)
                let res = await this.$store.state.$pouch.put('masters', formula)
                if (res.ok) {
                    this.$store.commit("showSnackbar", {text: "Formula salvata", color: 'primary'})
                } else {
                    this.$store.commit("showSnackbar", {text: "Problemi con il salvataggio", color: 'error'})
                }
            } catch(error) {
                this.$store.commit("showSnackbar", {text: "Problemi con il salvataggio", color: 'error'})
                console.log('error', error)
            }
        }, 
        addRow(){
            if(this.value && this.value.fixed_params){
                let clone = JSON.parse(JSON.stringify(this.value.data));
                this.items.push(clone);
            } else {
                if(this.items.length > 0 ){
                    let temp = Object.keys(this.items[0])
                    let newItem = {}
                    for (let k of temp){
                        newItem[k] = 0
                    }
                    this.items.push(newItem)
                } else {
                    this.items.push({values: 0})
                }
            }
        },
        async getBlocks(){
            if(this.value){
                let f_sel = {doc_type: "baseblock"}
                f_sel.formulas = {"$in": [this.value._id]}
                console.log("selettore", f_sel)
                let res = await this.$store.state.$pouch.find("masters", {selector: f_sel, fields: ['_id', 'label', 'family']})
                console.log("risultato ricerca", res.docs)
                this.blocks = res.docs
            } else {
                this.blocks = []
            }
        },
        async getFormulas() {
            console.log("startato")
            let b_sel = {doc_type: 'formula'}
            // this.$store.state.$pouch.find("masters", {
            //    selector: b_sel
            // }).then((res) => {
            //     console.log('formule', res);
            //     this.formulas = res.docs;
            //     this.loadFormulas = false;
            // });
            this.$store.state.$pouch.query("masters","formulas",{
                include_docs: true
            }).then( res => {
                for (let elem of res.rows){
                    this.formulas.push(elem.doc)
                }
                this.loadFormulas = false
            })
        },
        processFile(){
            console.log("test file input", this.files[0])
            this.$papa.parse(this.files[0].file, {header: true, skipEmptyLines: 'greedy', complete: (results) => {
                this.items = results.data
                console.log("results parsing", this.items)
                // let cose = this.$papa.unparse(results)
                // console.log("tentativo 2", cose)
                // this.download("esempio.csv", cose)
            }})
        },
        download(filename, text) {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-csv file
                if (!/\.(csv)$/i.test(newFile.name)) {
                return prevent()
                }
            }
        },
        exportData(){
            let converted = null;
            if(!this.value.fixed_params){
                let cloned = JSON.parse(JSON.stringify(this.items))
                let tempo = Object.keys(cloned[0])
                let res = 0
                if (tempo.length > 1) {
                    res = this.calculateFunction(tempo[1]) // considero la seconda colonna per burette.csv
                } else {
                    res = this.calculateFunction(tempo[0])
                }
                for (let elm of cloned){
                    elm.result = ''
                }
                let newRow = {}
                for (let k of tempo){
                    newRow.k = ''
                }
                newRow.result = res
                cloned.push(newRow)
                converted = JSON.stringify(cloned)
            } else {
                let cloned = JSON.parse(JSON.stringify(this.items))
                for (let item of cloned){
                    item.result = this.doMagic(item)
                }
                console.log(cloned)
                converted = JSON.stringify(cloned)
            }
            let csved = this.$papa.unparse(converted)
            this.download(this.value._id + ".csv", csved)
        },
        calculateFunction(index){
            if (index){
                let temp = []
                for (let a of this.items){
                    temp.push(a[index])
                }
                let paramName = Object.keys(this.value.data)[0] // name of the variable, like a in stdev(a)
                var test = this.value.equation.replace(paramName, temp.toString())
                let pippo = nerdamer(test).evaluate().text()
                console.log("cose a caso", temp, pippo)
                return pippo
            }
        }
    },
    beforeMount() {
        this.getFormulas()
    },
}
</script>